const analysis = {
  bindings: {},
  templateUrl: '/modules/analysis/analysis-view/analysis.html',
  controller: 'AnalysisController',
};

angular
    .module('analysis.module')
    .component('analysis', analysis)
    .config(function ($stateProvider) {
        $stateProvider
            .state('analysis', {
                url: '/analysis',
                component: 'analysis',
                resolve: {
                    auth: function (userService, $state, eventService) {
                        return userService
                            .resolve(['ACCESS_ANALYSIS'])
                            .then(() => {
                            })
                            .catch(() => {
                                eventService.trigger('userservice:unauthorized');
                                $state.go('frontpage');
                            });
                    },
                },
            });
    });
